import { API } from "../../http-common";
// import axios from "axios";
export default {
  state: {
    status: "",
    data: {},
    token: "",
    role: "",
    homeLink: "",
    // distributorId:""
  },

  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.data = payload;
      state.token = payload.token;
      state.role = payload.role;
      // state.distributorId=payload.adminLogin.distributorId;
    },
    auth_error(state) {
      state.status = "error";
    },

    logout(state) {
      state.status = "";
      state.data = {};
      state.token = "";
      state.role = "";
      state.homeLink = "";
    },

    update_force_password(state) {
      state.data.adminLogin.forcePassword = false;
    },

    set_role(state, payload) {
      state.role = payload;
    },

    setHomeLink(state, payload) {
      state.homeLink = payload;
    },
  },

  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        API.post("/admin-login", {
          username: user.username,
          password: user.password,
        })
          .then((response) => {
            const res = response.data;
            // console.log(response)
            if (res.status) {
              const { adminLogin } = res.data;

              console.log('adminLogin', adminLogin)
              var roles = adminLogin.roles;


              for (var x = 0; x < roles.length; x++) {
                var role = roles[x];
                role.permissions = role.permissions.sort(function (r1, r2) {
                  if (r1.ordering > r2.ordering) {
                    return 1;
                  } else if (r1.ordering < r2.ordering) {
                    return -1;
                  }

                  return 0;
                })


              }


              commit("auth_success", res.data);
              resolve(res);
            } else {
              commit("auth_error");
              reject(res.message);
            }
          })
          .catch((error) => {
            commit("auth_error");
            reject(error.response.data.message);
          });

        // axios.post('https://gma.zed.ph/api/WOW_LOGIN', user, config)
        //   .then(response => {
        //     console.log(response)
        // if (resp.data.statusCode == 3) {
        //   // alert("Invalid username/password")
        //   // return false
        //   reject("Invalid username/password");
        // }
        // let response = resp.data;
        // localStorage.setItem('token', response.message)
        // response.username = user.UserName;
        // axios.defaults.headers.common['Authorization'] = token
        // commit('auth_success', response)
        // resolve(resp)
        // })
        // .catch(err => {
        //   commit('auth_error')
        //   localStorage.removeItem('token')
        //   reject(err)
        // })
      });
    },

    session({ commit }) {
      return new Promise((resolve, reject) => {
        // commit("auth_request");
        API.get("/session")
          .then((response) => {
            const data = response.data;

            if (!data.status) {
              commit("logout");
              window.location = "/";
            }
            console.log("session", data.status);
            resolve(response);
          })
          .catch((error) => {
            commit("auth_error");
            reject(error);
          });
      });
    },

    logout({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit("logout");
          // localStorage.removeItem('token')
          // delete API.defaults.headers.common['wsc-token']
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    set_force_password({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit("update_force_password");
          // localStorage.removeItem('token')
          // delete API.defaults.headers.common['wsc-token']
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    add_role({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit("set_role", payload);

          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    addHomeLink: ({ commit }, payload) => {
      commit("setHomeLink", payload);
    },
  },

  getters: {
    isLoggedIn: (state) => !!state.data,
    authStatus: (state) => state.status,
    token: (state) => state.token,
    userData: (state) => state.data,
    userRole: (state) => state.role,
    getHomeLink: (state) => state.homeLink,
  },
};
